import React from "react";
import { Badge } from "@/components/ui/badge";
import { features } from "@/config/feature-toggles";

const PrototypeBadge = () => {
  if (!features.showNetoBadge) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50">
      <Badge 
        variant="outline" 
        className="bg-[#0F2A35] text-white border border-[#0F2A35] py-1 px-2.5 text-xs font-medium shadow-md hover:bg-[#0F2A35]/90 transition-colors duration-200"
      >
        Prototype by Neto Ventures
      </Badge>
    </div>
  );
};

export default PrototypeBadge;
